import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PacksCreateComponent } from './packs-create/packs-create.component';
import { PacksListComponent } from './packs-list/packs-list.component';







const routes: Routes = [

    { path: '', component: PacksListComponent  },
    { path: 'edit/:id', component: PacksCreateComponent },
    { path: 'crear', component: PacksCreateComponent }, 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppPacksRoutingModule {}
